var NoHolidayService = /** @class */ (function () {
    function NoHolidayService() {
        this.dashboardJobibot = 'jobilla-dashboard';
        this.textJobibot = 'jobibot-text';
        this.jobibot = 'jobibot';
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    NoHolidayService.prototype.applyScreenEffect = function () { };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    NoHolidayService.prototype.cancelScreenEffect = function () { };
    NoHolidayService.applicable = function () {
        return true;
    };
    return NoHolidayService;
}());
export default NoHolidayService;
